/* Step indicator bar for the document stepper
   Created: Shows 3 steps with numbered circles, connecting lines, and active state */

import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

interface StepIndicatorProps {
  currentStep: number;
  steps: string[];
}

export default function StepIndicator({ currentStep, steps }: StepIndicatorProps) {
  return (
    <div className="flex items-center justify-center mb-10">
      {steps.map((label, index) => {
        const stepNum = index + 1;
        const isActive = stepNum === currentStep;
        const isCompleted = stepNum < currentStep;

        return (
          <div key={label} className="flex items-center">
            <div className="flex flex-col items-center">
              <motion.div
                initial={false}
                animate={{
                  backgroundColor: isCompleted ? '#153907' : isActive ? '#153907' : '#e5e7eb',
                  scale: isActive ? 1.1 : 1,
                }}
                transition={{ duration: 0.3 }}
                className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold ${
                  isCompleted || isActive ? 'text-white' : 'text-gray-500'
                }`}
              >
                {isCompleted ? <Check className="w-5 h-5" /> : stepNum}
              </motion.div>
              <span
                className={`mt-2 text-xs font-medium ${
                  isActive ? 'text-jv-primary' : isCompleted ? 'text-gray-700' : 'text-gray-400'
                }`}
              >
                {label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className="relative w-24 mx-2 mb-6">
                <div className="h-0.5 bg-gray-200 w-full" />
                <motion.div
                  initial={false}
                  animate={{ width: isCompleted ? '100%' : '0%' }}
                  transition={{ duration: 0.4 }}
                  className="absolute top-0 left-0 h-0.5 bg-jv-primary"
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
